// extracted by mini-css-extract-plugin
export var chapterCardInnerStyle = "sr_chapter_card-module--chapterCardInnerStyle--Cy5w-";
export var currentChapterStyle = "sr_chapter_card-module--currentChapterStyle---8rBC";
export var linkWrapperStyle = "sr_chapter_card-module--linkWrapperStyle--+E4MB";